module.exports = __webpack_public_path__ + "img/credit-card-outline.eb6fec84.svg";